export const LOW_ROOM_SLUG = 'low_room';
export const HIGH_ROOM_SLUG = 'high_room';

export const STARTING_GAME = 'starting-game';
export const INGAME = 'ingame';

export const FIRST_TICKET: number = 1;

export const JACKPOT_PLAYER_COLORS = [
    '#FFE24B',
    '#1380FF',
    '#E292FF',
    '#FA3C18',
    '#4FFF8B',
    '#9D3BFB',
];
